import Cookies from "js-cookie";

const SingleTeam = ({
  itemClass,
  teamImage,
  authorName,
  designation,
  id,
  membershipId,
}) => {
  const token = Cookies.get("token");
  const role = Cookies.get("role");

  const Wrapper = token && role ? "a" : "div";

  return (
    <Wrapper
      {...(token && role ? { href: `/member-card-details?id=${id}` } : {})}
      className={itemClass ? itemClass : "it-team-item"}
    >
      <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
        {/* Image container with hover effect */}
        <div className="relative w-full h-64 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
          <img
            src={teamImage}
            alt={authorName}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          {/* Subtle overlay that appears on hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>

        {/* Content section with padding */}
        {/* Content section with padding */}
        <div className="py-3 px-3">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <h5 className="font-semibold text-lg text-gray-800 mb-2 group-hover:text-purple-600 transition-colors duration-200">
                <span className="hover:text-purple-600 transition-colors duration-200">
                  {authorName}
                </span>
              </h5>

              <div className="flex flex-col gap-1">
                <span className="text-sm font-medium w-max text-purple-600 bg-purple-50 px-2 py-1 rounded-full inline-block">
                  {designation}
                </span>
                {membershipId && (
                  <span className="text-xs font-medium w-max text-purple-600 bg-purple-50 px-2 py-1 rounded-full inline-block">
                    ID: {membershipId}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default SingleTeam;
